import merchantSlice from './merchantSlice';

export default merchantSlice;
